import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  countMatches: number
  remainingDocs: number
  signatureRequested: boolean
}

const Info = ({ countMatches, remainingDocs, signatureRequested }: Props) => (
  <Box
    padding="s16"
    paddingRight="s32"
    border={{
      all: {
        color: 'grey400',
        width: 's1',
        style: 'solid',
      },
    }}
    borderRadius={
      countMatches === 0 || !signatureRequested
        ? {
            all: 'abs008',
          }
        : {
            topLeft: 'abs008',
            topRight: 'abs008',
          }
    }
  >
    <Box flexDirection="row">
      <Box flexDirection="row" alignItems="center" width="full-view-height">
        <Text.Normal weight="bold">
          {countMatches === 0
            ? i18n.t('split_documents.bulk_modal.results.title_no_matches')
            : i18n.t('split_documents.bulk_modal.results.title_v2')}
        </Text.Normal>
      </Box>
      {countMatches > 0 && (
        <Box
          alignItems="flexEnd"
          width="full"
          gap="s16"
          aria-label={i18n.t('split_documents.bulk_modal.results.title_v2')}
        >
          <Text.Normal weight="bold" size="300">
            {countMatches}
          </Text.Normal>
        </Box>
      )}
    </Box>
    <Box paddingTop="s16" gap="s16" alignItems="flexStart">
      {remainingDocs > 0 && (
        <Tag type="radical">
          {i18n.t('split_documents.bulk_modal.results.remaining_v2', {
            count: remainingDocs,
          })}
        </Tag>
      )}
    </Box>
  </Box>
)

export default Info
